import Vue from 'vue';
// import IdleVue from 'idle-vue';
import Vuelidate from 'vuelidate';
import VuejsDialog from 'vuejs-dialog';
import VueClipboard from 'vue-clipboard2';

import router from './helpers/router';
import store from './store/index';

import App from './components/App.vue';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import './assets/scss/app.scss';

// const eventsHub = new Vue();

/*Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 3000,
});*/
Vue.use(VueClipboard);
Vue.use(Vuelidate);
Vue.use(VuejsDialog, {
    animation: 'fade',
    cancelText: 'Sluiten',
});

new Vue({
    router,
    store,
    /*onIdle () {
        console.log('ZZZZ');
        this.$store.dispatch('account/logout');
    },*/
    render: (h) => h(App),
}).$mount('#app');
